import * as isomorphicLocalStorage from 'lib/storage/isomorphicLocalStorage'

/** Used for logout cleanup in `userMiddleware` (same prefix as snapshot keys). */
export const LOYALTY_REWARDS_STORAGE_PREFIX = 'loyalty-societe-rewards-'

/**
 * Legacy localStorage keys from removed `tierProgressSnackbar` module; still removed on logout so old
 * clients do not leave stale keys behind.
 */
export const LEGACY_TIER_PROGRESS_SNACKBAR_STORAGE_PREFIX = 'loyalty-tier-progress-snackbar-'

const STORAGE_PREFIX = LOYALTY_REWARDS_STORAGE_PREFIX

export interface LoyaltyRewardsLastSeenBalance {
  points: number
  statusCredits: number
  nights: number
  /** Tier at the time the snapshot was taken — used to detect tier upgrades. */
  tier: App.LoyaltyTier
}

function getStorageKey(memberId: string) {
  return `${STORAGE_PREFIX}${memberId}`
}

export function getLastSeenBalance(memberId: string): LoyaltyRewardsLastSeenBalance | undefined {
  return isomorphicLocalStorage.get(getStorageKey(memberId)) as LoyaltyRewardsLastSeenBalance | undefined
}

export function setLastSeenBalance(memberId: string, balance: LoyaltyRewardsLastSeenBalance): void {
  isomorphicLocalStorage.set(getStorageKey(memberId), balance)
}
